"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormFeedback = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactstrap = require("reactstrap");
var _fonts = require("../fonts");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var FormFeedback = (0, _styledComponents.default)(_reactstrap.FormFeedback).attrs(function (props) {
  return {
    children: /*#__PURE__*/_react.default.createElement(_fonts.Small, null, props.children)
  };
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n  margin-top: 10px;\n"])), function (_ref) {
  var theme = _ref.theme,
    valid = _ref.valid;
  return valid ? theme.colors.success : theme.colors.danger;
});
exports.FormFeedback = FormFeedback;